import { useCallback, useImperativeHandle, forwardRef, Ref } from 'react';
import { showDialogConfirm } from '@octano/global-ui';

import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

export interface ConfirmExistingAccountModalContext {
  onConfirm: () => void;
}

export interface ConfirmExistingAccountModalMethods {
  open: (ctx: ConfirmExistingAccountModalContext) => void;
}

interface Props {
  onConfirm?: () => void;
}

const ConfirmExistingAccountModal = (
  { onConfirm }: Props,
  ref: Ref<ConfirmExistingAccountModalMethods>,
) => {
  const { t } = useTranslation(
    TranslationsKeys.TEACHER_MANAGMENT_TEACHER_ACTIVATION,
  );

  const handleOpen = useCallback(
    (ctx: ConfirmExistingAccountModalContext) => {
      showDialogConfirm({
        title: t('existingAccountConfirmation.title'),
        subtitle: t('existingAccountConfirmation.description'),
        btnConfirm: {
          text: t(`common:actions.confirm`),
          onConfirm: () => {
            ctx.onConfirm();
            !!onConfirm && onConfirm();
          },
        },
        btnClose: {
          text: t(`common:actions.cancel`),
        },
      });
    },
    [t, onConfirm],
  );

  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  return <></>;
};

export default forwardRef(ConfirmExistingAccountModal);
